import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
        className="glass rounded-3xl p-10 text-center max-w-md w-full" data-testid="payment-cancel-card">
        <h1 className="font-serif text-3xl tracking-tight mb-2">No worries.</h1>
        <p className="text-muted-foreground text-sm mb-7">Your checkout was cancelled and you haven't been charged. Premium is here whenever you're ready.</p>
        <div className="flex flex-col gap-2.5">
          <Button className="rounded-full" onClick={() => navigate("/upgrade")} data-testid="payment-cancel-retry">See Premium again</Button>
          <Button variant="ghost" className="rounded-full" onClick={() => navigate("/app")} data-testid="payment-cancel-home">
            <ArrowLeft className="w-4 h-4 mr-1" /> Back to Xcelio
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
